import React, { useContext, useEffect, useRef, useState } from "react";
import B2BFormContainer from "../../../b2b-common/B2BFormContainer";
import B2BStepper from "../../../b2b-common/B2BStepper";

import SearchOrganizationsPaged from "../organization/SearchOrganizationsPaged";
import MembershipRoles from "./MembershipRoles";
import { LoginContext } from "../../../../App";
import { createUserMembershipByUserId, fetchOrganizationRoles } from "../../../../services/b2b-users-apiService";

import './UserNewMemberOfOrganization.css';
import LoadingMessage from "../../../b2b-common/LoadingMessage";

const UserNewMemberOfOrganization = ({ user, onClose, onNewMemberCreated }) => {
    const [newUserOrganization, setNewUserOrganization] = useState(null);
    const [organizationRoles, setOrganizationRoles] = useState(null);
    const [userRoles, setUserRoles] = useState(null);
    const [creatingNewMember, setCreatingNewMember] = useState(false);

    const { loginData } = useContext(LoginContext);

    const refNewMemberOfOrganization = useRef({});

    useEffect(() => {
        if (refNewMemberOfOrganization.current) {
            refNewMemberOfOrganization.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [])

    useEffect(() => {
        if (newUserOrganization && newUserOrganization.organizationUUID) {
            const { accessToken } = loginData;
            fetchOrganizationRoles(newUserOrganization.organizationUUID, accessToken)
                .then(response => {
                    setOrganizationRoles(response);
                })
                .catch(error => {
                    console.log('error fetching roles: ', error);
                });
        }
    }, [newUserOrganization])

    const handleSelectOrganization = (organization) => {
        setNewUserOrganization(organization);
    };

    const handleFinalStep = async () => {
        try {
            const { accessToken } = loginData;
            setCreatingNewMember(true);
            const firstRoleName = userRoles.length > 0 ? userRoles[0].roleName : "USER";
            const newMembership = await createUserMembershipByUserId(newUserOrganization.organizationUUID, user.userId, firstRoleName, accessToken);
            if (newMembership) {
                //console.log('new membership: ', newMembership);
                onNewMemberCreated(newMembership);
                onClose();
            }
        } catch (error) {
            console.error('Failed to create membership:', error.message);
            alert('Failed to create membership.');
        } finally {
            setCreatingNewMember(false);
        }
    };

    const steps = [
        {
            label: newUserOrganization ? `Select Organization [${newUserOrganization.organizationName}]` : 'Select Organization',
            description:
                'Select one of the listed organizations.',
            content: (
                <SearchOrganizationsPaged
                    uuidsBlacklist={user.userOrganizations}
                    elementsPerPage={5}
                    forceRefresh={null}
                    onSelectedOrganization={handleSelectOrganization}
                    className='new-member-organizations-list-search'
                />
            ),
            disableNext: (!newUserOrganization) ? true : false,
        },
        {
            label: userRoles ? `Select Roles [${userRoles.map(role => role.roleName).join(', ')}]` : 'Select Roles',
            description: `Which roles may have this user?`,
            content: (
                <div className="new-member-organization-roles">
                    {organizationRoles &&
                        <MembershipRoles
                            organizationRoles={organizationRoles}
                            memberRoles={userRoles}
                            onUpdateRoles={(roles) => setUserRoles(roles)}
                        />
                    }
                </div>
            ),
            disableNext: (!userRoles) ? true : false,
        },
    ];

    return (
        <B2BFormContainer title={`New organization for ${user.firstName} ${user.lastName}`} onClose={onClose} ref={refNewMemberOfOrganization}>
            {creatingNewMember ? (
                <LoadingMessage message="Please wait while we process your request..." />
            ) : (
                <B2BStepper steps={steps} onSuccess={handleFinalStep} />
            )}
        </B2BFormContainer>
    );
};
export default UserNewMemberOfOrganization;